import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';


// import all Model Objects and Intefaces Goes here...


@Injectable()
export class TechTrainingManualService {


  // below endpoint URL with Web API localhost:8080 in Dev or Prod environments
  private endpointURL_All = 'tech-training-manual/all';
  private endpointURL_New = 'tech-training-manual/new';

  // pleae comment this later when mock testing is done
  // private endpointURL_All = "mockdata/tech-training-manuals/all-tech-training-manuals.json";
  // private endpointURL_New = "mockdata/tech-training-manuals/new-tech-training-manuals.json";
  // private endpointURL_Recent = "mockdata/tech-training-manuals/recent-tech-training-manuals.json";

  constructor(private http: HttpClient) { }

  /** GET TechTrainingManuals from the server */

  getAllTechTrainingManuals(): Observable<any> {
    return this.http.get(this.endpointURL_All,{withCredentials : true});
  }

  getAllTechTrainingManualsForAdmin(makeName): Observable<any> {
    return this.http.get(this.endpointURL_All + '/makeName/' + makeName, {withCredentials : true});
  }

  getNewTechTrainingManuals(): Observable<any> {
    return this.http.get(this.endpointURL_New,{withCredentials : true});
  }

  getRecentTechTrainingManuals(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/techTrainingManualHistorylist`,{withCredentials : true});
  }
  addManualToUserHistory(userId, manualId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addTechTrainingManualToHistorylist/${manualId}`, '',{withCredentials : true});
  }
}
